module.exports = __webpack_public_path__ + "img/apple_download_ready.dc92f982.png";